var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white border-b-2 border-gray-100 shadow-md"},[_c('vue-navigation-bar',{staticClass:"container max-w-6xl",attrs:{"options":_vm.navbarOptions},on:{"vnb-item-clicked":_vm.vnbItemClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }